import  styled  from "styled-components";
import { Chip } from '@mui/material';
import { IStyledEyeBrowProps } from './eyeBrow';

interface IStyledEyeBrow extends IStyledEyeBrowProps {
  paddingTop?: string;
}

export const StyledEyeBrow = styled(Chip)<IStyledEyeBrow>`
  ${({ theme, paddingTop }) => `
    padding-top: ${paddingTop} !important;
    padding-left: ${theme.uptimeSpace[2]}px !important;
    padding-right: ${theme.uptimeSpace[2]}px !important;
    padding-bottom: 0 !important;
    .MuiChip-label {
      font-size: ${theme.uptimeDynamicFontSize?.eyeBrow ?? `${theme.uptimeFontSizes?.desktop.fz2}px`};
      line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
      padding: 0 ${theme.uptimeSpace[3]}px !important;
      letter-spacing: 0.16px;
    }
    .MuiSvgIcon-root{
      margin: 0 !important;
    }
    .MuiChip-deleteIcon{
      margin: 0 !important;
    }
  `}
`;